import imgFallback from "public/img-fallback.png";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { Image } from "@/components/common";

type Props = {
  title: string;
  subtitle?: string | number | null;
  imageUrl?: string | null;
  imageAlt: string;
  url?: string;
  upperElements?: ReactNode;
  lowerElements?: ReactNode;
};

export const TalentCardLayout = ({ title, subtitle, imageUrl, imageAlt, url, upperElements, lowerElements }: Props) => {
  const cardContent = (
    <>
      <Image src={imageUrl || imgFallback} alt={imageAlt} fill className="object-cover" />

      <div className="shadow-talent-card absolute bottom-0 left-0 right-0 px-2 pb-4">
        <div className="min-w-0 pr-10 text-white">
          <p className="whitespace-normal break-words font-medium">{title}</p>
          {subtitle != null && <p className="whitespace-normal break-words text-xs">{subtitle}</p>}
        </div>
      </div>
    </>
  );

  return (
    <div className="relative h-full w-full bg-white group">
      {url ? (
        <Link to={url} className="block h-full w-full">
          {cardContent}
        </Link>
      ) : (
        <div className="h-full w-full">{cardContent}</div>
      )}

      {upperElements}

      {lowerElements && (
        <div className="absolute bottom-4 right-2 z-20 flex translate-y-1/2 items-center gap-1 text-white">
          {lowerElements}
        </div>
      )}
    </div>
  );
};
